import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { trackPageView, identifyVisitor } from "../lib/tracker";

/**
 * Logs every route change with the anonymous visitor id, and stitches the
 * visitor's history onto the account the moment a user is authenticated
 * (covers login, signup, Google, SSO and invite-accept in one place).
 * Renders nothing.
 */
export default function PageViewTracker() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    trackPageView(location.pathname + (location.search || ""));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (user?.user_id) identifyVisitor(user.user_id);
  }, [user?.user_id]);

  return null;
}
